var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import {callApi} from "./api";
export function uploadFile(file) {
  return __async(this, null, function* () {
    var _a, _b;
    const fd = new FormData();
    fd.append("file", file, Date.now() + ".jpg");
    const r = yield callApi(`/file/avatar/`, {
      method: "POST",
      headers: {"content-type": "multipart/form-data"},
      body: fd
    });
    if (!r.ok)
      throw Error((_b = (_a = r.payload) == null ? void 0 : _a.data) == null ? void 0 : _b.message);
    return r.payload.data;
  });
}
export function resizeImage(file, maxSize = 1200) {
  return __async(this, null, function* () {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const img = document.createElement("img");
        img.src = reader.result;
        img.onload = () => {
          const {width, height} = calculateAspectRatioFit(img.width, img.height, maxSize, maxSize);
          const canvas = document.createElement("canvas");
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, width, width);
          canvas.toBlob(resolve, "image/jpeg", 0.8);
        };
      };
    });
  });
}
function calculateAspectRatioFit(width, height, maxWidth, maxHeight) {
  const ratio = Math.min(maxWidth / width, maxHeight / height);
  return ratio <= 1 ? {width: width * ratio, height: height * ratio} : {width, height};
}
